import * as Output from '../../Text';

const errorMessage = Output.resolve('generic.errors.M012_ValidCurrencyAmount');

export const money = v => {

  if (!v) {
    return undefined;
  }

  if (!/^(?![.,])[\d.]*(?:,\d{1,2})?$/.test(v)) {
    return errorMessage;
  }

  const number = Number.parseFloat(v.replace(/\./g, '').replace(/,/g, '.'));

  if (Number.isNaN(number)) {
    return errorMessage;
  }

  if (number < 0 || number > 999999) {
    return errorMessage;
  }

  return undefined;
};
